<template>
  <div class="mainCenter">
    <div id="advertisement">
      <div class="asider-right">
        <div
          class="asider-wxcustomerService"
          @mouseenter="asiderService"
          @mouseleave="asiderService"
          @click="jumpPage"
          v-if="showReturn"
        >
          <div class="asider-wxcustomerService-img" :class="wxServive"></div>
          <p>在线客服</p>
        </div>
        <div class="asider-top" @mouseenter="asider" @mouseleave="asider" @click="toTopFn" v-if="showReturn">
          <a>
            <div class="asider-top-img" :class="toTopClass"></div>
            <p>返回顶部</p>
          </a>
        </div>
      </div>
      <div class="container-box">
        <div class="link01-panel" :class="openPanel">
          <div class="panel-container">
            <div class="close" @click.stop="closePanel01">
              <img src="../../../assets/images/mall/closePop.png" alt="" />
            </div>
            <div class="setBox" v-for="(oitem, i) in allCar" :key="i">
              <p class="bigSize">{{ oitem.frontCategory.name }}</p>
              <div v-for="(item, i) of oitem.items" :key="i">
                <!-- <div class="mainCar" v-if="((!item.activityTag)||(item.activityTag && item.activityTag.activityTypeCode!=='crowdFunding'))"> -->
                <div class="mainCar" v-if="!item.activityTag || item.activityTag">
                  <!-- 限时抢购 -->
                  <div
                    :class="
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.activityType &&
                      item.activityItemInfoDto.activityInfoDto.activityType === 5
                        ? 'DepositAc Deposit'
                        : ''
                    "
                    v-if="adRoute(item).type === 'flashSale'"
                  ></div>
                  <router-link :to="adRoute(item, 'mallCar').url + item.id" class="product-link">
                    <!--<div class="panel-item-img-car" :style="'background-image:url(' + item.mainImage + ')'"></div>-->
                    <el-image class="panel-item-img-car" :src="item.mainImage" fit="contain"></el-image>
                  </router-link>
                  <div class="item-name-car">
                    <p v-text="item.name"></p>
                    <p class="range-car">
                      <!-- {{ (item.lowPrice / 10000) | currency('', 2) }}万&nbsp;&nbsp;-&nbsp;&nbsp;{{
                        (item.highPrice / 10000) | currency('', 2)
                      }}万 -->
                      {{ item.extra && item.extra.originPrice }}
                    </p>
                  </div>
                  <p class="hoverFind">
                    <button class="find-car">
                      <router-link :to="adRoute(item, 'mallCar').url + item.id" class="product-link"
                        >查看详情</router-link
                      ></button
                    ><button class="bespeak-car">
                      <a :href="pathData.testdrive">预约试驾</a>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <!-- 左侧边栏 -->
          <div class="asider">
            <div class="asider-link01" @click="openPanel01">
              <div class="link01-title" :class="addActive">
                <span>全线车系</span>
                <span class="link01-pointer"></span>
              </div>
            </div>
            <div class="line"></div>
            <div class="asider-link02" @click="openPanel02">
              <div class="link02-title" :class="addActiveSed">
                <span>奇瑞精选</span>
                <span class="link02-pointer"></span>
              </div>
              <div class="link02-panel" :class="openPanelSed">
                <div class="panel02-container">
                  <div class="close" @click.stop="closePanel02">
                    <img src="../../../assets/images/mall/closePop.png" alt="" />
                  </div>
                  <div v-for="(item, i) in bestCar" :key="i">
                    <router-link :to="'/seller/malljp/' + item.code" class="product-link">
                      <div class="panel02-item-img" :style="'background-image:url(' + item.logo + ')'"></div>
                      <!--<el-image class="panel02-item-img" :src="item.logo" fit="contain"></el-image>-->
                      <p class="item-name" v-text="item.name"></p>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="asider-link03">
              <div class="row">
                <a :href="pathData.carBalance">
                  <div class="compare" :class="compare" @mouseenter="compareTabs" @mouseleave="compareTabs"></div>
                </a>
                <a :href="pathData.activityPage">
                  <div class="finance" :class="finance" @mouseenter="financeTabs" @mouseleave="financeTabs"></div>
                </a>
              </div>
              <div class="driver-row">
                <a :href="pathData.testdrive">
                  <div class="driver" :class="driver" @mouseenter="driverTabs" @mouseleave="driverTabs"></div>
                </a>
              </div>

              <div class="business-row">
                <a :href="pathData.dealer">
                  <div class="business" :class="business" @mouseenter="businessTabs" @mouseleave="businessTabs"></div>
                </a>
                <a :href="pathData.twoCar">
                  <div
                    class="secondhand"
                    :class="secondHand"
                    @mouseenter="secondHandTabs"
                    @mouseleave="secondHandTabs"
                  ></div>
                </a>
              </div>
            </div>
          </div>
          <!-- banner图 -->
          <el-carousel :interval="5000" arrow="never" class="banner">
            <el-carousel-item v-for="(item, i) in bannerImages" :key="i" class="bannerItem">
              <a v-if="item.link" :href="item.link"
                ><img class="bannerImg" :src="item.backgroundPicture" alt="item.title"
              /></a>
              <img v-else class="bannerImg" :src="item.backgroundPicture" alt="item.title" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pathData from '../../../assets/data/path-data'
import { ActivityRoute } from '@/lib/utils'
export default {
  name: 'advertisement',
  data() {
    return {
      showDots: true,
      isCompare: false,
      isFinance: false,
      isDrive: false,
      isbusiness: false,
      isSecondHand: false,
      isTop: false,
      isOpen: false,
      isOpenSed: false,
      isActive: false,
      isActiveSed: false,
      activeIndex: 1,
      timer: null,
      isTransition: false,
      showReturn: false,
      transitionInterval: 500, // transition duration
      isResetIndex: false, // 是否瞬间重置定位，在watch中初始化，重置定位取消transition
      service: false,
      mini: false,
      pathData: pathData
    }
  },
  props: {
    bannerImages: {
      type: Array,
      default: () => []
      // {link: ''}
    },
    allCar: {
      type: Array,
      default: () => []
    },
    bestCar: {
      type: Array,
      default: () => []
    }
  },
  created() {},
  watch: {},
  computed: {
    wxmini() {
      return {
        'asider-wxmini-img-active': this.mini
      }
    },
    wxServive() {
      return {
        'asider-wxcustomerService-img-active': this.service
      }
    },
    compare() {
      return {
        'compare-active': this.isCompare
      }
    },
    finance() {
      return {
        'finance-active': this.isFinance
      }
    },
    business() {
      return {
        'business-active': this.isbusiness
      }
    },
    secondHand() {
      return {
        'secondhand-active': this.isSecondHand
      }
    },
    driver() {
      return {
        'driver-active': this.isDrive
      }
    },

    toTopClass() {
      return {
        'asider-top-img-active': this.isTop
      }
    },
    openPanel() {
      return {
        openSlider01: this.isOpen
      }
    },
    openPanelSed() {
      return {
        openSlider02: this.isOpenSed
      }
    },
    addActive() {
      return {
        active2: this.isActive
      }
    },
    addActiveSed() {
      return {
        active2: this.isActiveSed
      }
    }
  },
  methods: {
    adRoute(attr, productType) {
      return ActivityRoute(attr, productType)
    },
    jumpPage() {
      window.open(
        this.pathData.service,
        '_blank',
        'width=900,height=630,menubar=no,toolbar=no,status=no,scrollbars=yes'
      )
    },
    getHeight() {
      var _this = this
      window.onscroll = function(e) {
        e = e || window.event
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        if (this.scrollTop > 100) {
          _this.showReturn = true
        } else {
          _this.showReturn = false
        }
      }
    },
    compareTabs() {
      this.isCompare = !this.isCompare
    },
    financeTabs() {
      this.isFinance = !this.isFinance
    },
    businessTabs() {
      this.isbusiness = !this.isbusiness
    },
    secondHandTabs() {
      this.isSecondHand = !this.isSecondHand
    },
    driverTabs() {
      this.isDrive = !this.isDrive
    },
    toTopFn() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },
    asiderMini() {
      this.mini = !this.mini
    },
    asiderService() {
      this.service = !this.service
    },
    asider() {
      this.isTop = !this.isTop
    },
    openPanel01() {
      this.isOpenSed = false
      this.isActiveSed = false
      this.isOpen = !this.isOpen
      this.isActive = !this.isActive
    },
    closePanel01() {
      this.isOpen = false
      this.isActive = false
    },
    openPanel02() {
      this.isOpen = false
      this.isActive = false
      this.isOpenSed = !this.isOpenSed
      this.isActiveSed = !this.isActiveSed
    },
    closePanel02() {
      this.isOpenSed = false
      this.isActiveSed = false
    },
    activeDotFn(e) {
      if (e.target.tagName.toLowerCase() === 'li') {
        let index = parseInt(e.target.getAttribute('data-dot-index'))
        this.activeIndex = index
      }
    }
  },
  mounted() {
    this.getHeight()
  },
  components: {}
}
</script>
<style lang="scss" scoped>
#advertisement {
  width: 100%;
  background: #fff;
  padding-bottom: 20px;
  box-sizing: border-box;
}
html {
  scroll-behavior: smooth;
}
.container-box {
  width: 1360px;
  height: 480px;
  margin: 0 auto;
  position: relative;
  border: 1px solid rgba(245, 245, 245, 1);
}
.container {
  box-sizing: border-box;
  width: 1360px;
  height: 480px;
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  // overflow: hidden;
}
.asider {
  position: absolute;
  width: 260px;
  height: 100%;
  z-index: 10;
  -webkit-background-size: 260px 480px;
  background-size: 260px 480px;
  background: url('../../../assets/images/mall/bannerbg.png');
}
.asider-link01 {
  width: 100%;
  height: 56px;
  position: relative;
  margin-top: 30px;
}
.line {
  width: 200px;
  height: 1px;
  background: #ffffff;
  opacity: 0.2;
  margin-left: 30px;
  margin-top: 10px;
}
.link01-title,
.link02-title {
  width: 200px;
  height: 56px;
  margin-left: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  span {
    line-height: 28px;
    font-size: 20px;
    font-weight: 400;
    color: #ffffff;
  }
}
.link01-title:hover:after,
.link02-title:hover:after {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  border-bottom: 4px solid #ff2441;
  animation: navhover 0.3s ease;
}
.product-link {
  text-decoration: none;
}
.link01-panel {
  /* width: 1100px; */
  overflow: hidden;
  width: 0;
  position: absolute;
  top: 0;
  left: 260px;
  z-index: 5;
  /*box-shadow:0 0px 2x 1px rgba(28,47,64,0.35);*/
  display: none;
}
.panel-container {
  display: flex;
  flex-direction: column;
}
.setBox {
  width: 1030px;
  margin-left: 35px;
  min-height: 230px;
  margin-top: 30px;
  box-sizing: border-box;
  .bigSize {
    margin-left: 11px;
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: 900;
    line-height: 28px;
    position: relative;
  }
  .bigSize:after {
    content: '';
    width: 4px;
    height: 20px;
    background: #c6001f;
    position: absolute;
    left: -18px;
    top: 5px;
  }
}
.setBox:nth-of-type(3) {
  border-bottom: 1px solid #dcdcdc;
}
.set:last-of-type {
  border-bottom: 0;
}
.panel-container {
  width: 1100px;
  min-height: 480px;
  overflow: hidden;
  background: rgba(255, 255, 255, 1);
  .close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
    z-index: 8;
    img {
      width: 24px;
      height: 24px;
    }
  }
}
.panel-container .mainCar {
  width: 212px;
  height: 160px;
  float: left;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  margin-bottom: 30px;
  text-align: center;
  position: relative;
  .hoverFind {
    display: none;
  }
  .DepositAc {
    z-index: 2;
    height: 66px;
    width: 60px;
    background-size: 60px 66px;
    background-image: url('../../../assets/images/mall/flashSale.png');
    position: absolute;
    top: 0px;
    right: 0;
  }
  .oneprice {
    height: 66px;
    width: 60px;
    background-size: 60px 66px;
    background-image: url('../../../assets/images/mall/oneprice.png');
  }
}
.panel-container .mainCar:hover {
  .hoverFind {
    display: inline;
  }
}
.panel-item-img {
  width: 100%;
  height: 100px;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.panel-item-img-car {
  width: 156px;
  height: 88px;
  margin: 0 auto;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin-bottom: 14px;
}
.item-name {
  font-size: 18px;
  font-weight: 500;
  color: rgba(57, 60, 81, 1);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-name-car p:first-child {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  line-height: 20px;
}
.item-name-car p:last-child {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}
.range-car {
  font-size: 14px;
  color: #868686;
}
.find-car,
.bespeak-car {
  width: 92px;
  height: 30px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(215, 215, 215, 1);
}
.bespeak-car {
  margin-left: 13px;
  color: #868686;
}
.item-name ~ p {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  color: rgba(119, 119, 119, 1);
}
.closeSlider {
  width: 0px;
}
.link02-panel {
  width: 0px;
  /* width: 500px; */
  min-height: 480px;
  padding-bottom: 30px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, 0.22);
  position: absolute;
  top: -109px;
  left: 260px;
  // overflow: hidden;
  display: none;
}
.panel02-container {
  width: 757px;
  min-height: 480px;
  /* padding-top: 49px; */
  padding-left: 62px;
  position: relative;
}
.panel02-container > div {
  width: 90px;
  height: 140px;
  /* background-color: lightcoral; */
  text-align: center;
  float: left;
  margin-top: 49px;
  margin-right: 82px;
}
.panel02-container {
  .close {
    z-index: 8;
    width: 24px;
    height: 24px;
    position: absolute;
    top: 20px;
    right: 82px;
    margin: 0;
    img {
      width: 24px;
      height: 24px;
    }
  }
}
.panel02-item-img {
  width: 90px;
  height: 90px;
  overflow: hidden;
  border-radius: 50%;
  position: relative;
  border: 1px solid #ccc;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  /* display: flex;
  justify-content: center;
  align-items: center; */
}
/* .panel02-item-img img {
  width: 85%;
} */
.panel02-item-img ~ p {
  margin-top: 25px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(57, 60, 81, 1);
}
.openSlider01 {
  width: 1100px;
  display: block;
}
.openSlider02 {
  width: 757px;
  display: block;
}
.asider-link02 {
  width: 100%;
  height: 56px;
  margin-top: 12px;
  position: relative;
}
.asider-link03 {
  width: 237px;
  height: 221px;
  margin: 60px auto 0px;
}
.row {
  width: 100%;
  height: 94px;
}
.compare {
  float: left;
  width: 109px;
  height: 94px;
  background: url('../../../assets/images/mall/compare.png') 0px 0px no-repeat;
  background-size: contain;
  /* background-image: url('../../../assets/images/mall/compare.png'); */
}
.compare-active {
  background: url('../../../assets/images/mall/compare-active.png') 0px 0px no-repeat;
  background-size: contain;
}
.finance {
  float: right;
  width: 109px;
  height: 94px;
  background: url('../../../assets/images/mall/finance.png') 0px 0px no-repeat;
  background-size: contain;
}
.finance-active {
  background: url('../../../assets/images/mall/finance-active.png') 0px 0px no-repeat;
  background-size: contain;
}
.driver-row,
.business-row {
  position: relative;
  width: 100%;
  height: 94px;
  /* background-color: lightcoral; */
}
.business {
  width: 109px;
  height: 94px;
  position: absolute;
  left: 0px;
  top: -69px;
  background: url('../../../assets/images/mall/business.png') 0px 0px no-repeat;
  background-size: contain;
}
.business-active {
  background: url('../../../assets/images/mall/business-active.png') 0px 0px no-repeat;
  background-size: contain;
}
.secondhand {
  width: 109px;
  height: 94px;
  position: absolute;
  right: 0px;
  top: -69px;
  background: url('../../../assets/images/mall/secondhand.png') 0px 0px no-repeat;
  background-size: contain;
}
.secondhand-active {
  background: url('../../../assets/images/mall/secondhand-active.png') 0px 0px no-repeat;
  background-size: contain;
}
.driver {
  width: 88px;
  height: 88px;
  background: url('../../../assets/images/mall/driver.png') no-repeat center;
  margin: 0 auto;
  position: absolute;
  top: -31px;
  left: 74px;
  background-size: contain;
}
.driver-active {
  background: url('../../../assets/images/mall/driver-active.png') no-repeat center;
  background-size: contain;
}

::v-deep .banner {
  width: 1100px;
  height: 480px;
  left: 260px;
  position: relative;
  overflow: hidden;
  .el-carousel__indicators--horizontal {
    left: 80%;
    > li {
      padding: 12px 6px;
    }
  }
  .el-carousel__button {
    width: 12px;
    height: 12px;
    background: #ffffff;
    border-radius: 100%;
    // border: 1px solid #ffffff;
  }
  .bannerItem {
    width: 1100px;
    height: 480px;
    // background-position: right;
    // background-size: 1100px 480px;
    // background-repeat: no-repeat;
    .bannerImg {
      width: 1100px;
      height: 480px;
    }
  }
}
// banner样式
// .banner {
//   width: 1100px;
//   height: 480px;
//   position: relative;
//   left: 260px;
//   /* position: absolute; */
//   overflow: hidden;
//   list-style: none;
//   > li {
//     padding: 0;
//     font-size: 0px;
//     float: left;
//     position: relative;
//     #PROMOTIONCODEID {
//       position: absolute;
//       top: 0;
//       bottom: 0;
//       left: 0;
//       right: 0;
//     }
//   }
//   .bannerItem {
//     width: 1100px;
//     height: 480px;
//     background-position: right;
//     background-size: 1100px 480px;
//     background-repeat: no-repeat;
//   }
// }
// .dot {
//   width: 500px;
//   height: 20px;
//   position: absolute;
//   right: 87px;
//   bottom: 21px;
//   /* background-color: lightcoral; */
// }
// .dot-num {
//   width: inherit;
//   height: inherit;
//   list-style: none;
//   display: flex;
//   justify-content: flex-end;
//   align-items: center;
// }
// .dot-num > li {
//   width: 11px;
//   height: 11px;
//   border-radius: 50%;
//   background-color: #cccccc;
//   margin-left: 6px;
// }
.active {
  background-color: #ffffff !important;
}
.link01-pointer,
.link02-pointer {
  display: block;
  margin-left: 105px;
  width: 10px;
  height: 18px;
  background-image: url('../../../assets/images/mall/asider-more.png');
  background-size: 100%;
}
.active2:after {
  // background: rgba(223, 61, 54, 1);
  // background-image: url("../../../assets/images/mall/asider-more-active.png");
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  border-bottom: 4px solid #ff2441;
}
/* 侧边栏 */
.asider-right {
  width: 82px;
  /* width: 300px; */
  position: fixed;
  bottom: 200px;
  right: 10px;
  z-index: 999;
  font-size: 13px;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
  /* background-color: lightcoral; */
}
.asider-wxcustomerService,
.asider-top {
  width: 82px;
  height: 90px;
  margin-bottom: 5px;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  // right: 165px;
  cursor: pointer;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #666;
  /* z-index: 5; */
}
// .asider-wxmini-code {
//   box-sizing: border-box;
//   width: 205px;
//   height: 205px;
//   background-image: url("../../../assets/images/mall/u74.png");
//   background-size: contain;
//   background-position: center;
//   background-repeat: no-repeat;
//   position: absolute;
//   top: -45px;
//   left: -210px;
//   text-align: center;
//   transform: rotate(-90deg);
//   padding-top: 15px;
//   img {
//     width: 80%;
//     transform: rotate(90deg);
//   }
// }
.asider-wxcustomerService-img,
.asider-top-img {
  width: 23px;
  height: 21px;
  margin: 29px auto 7px;
  // background-image: url("../../../assets/images/mall/asider-mini.png");
}
.asider-wxcustomerService-img {
  background-image: url('../../../assets/images/mall/asider-customerService.png');
  background-repeat: no-repeat;
  background-size: 100%;
}
.asider-wxcustomerService-img-active {
  background-image: url('../../../assets/images/mall/customerService.png');
  background-repeat: no-repeat;
  background-size: 100%;
}
.asider-top > a {
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  color: #666;
}
.asider-top-img {
  background-image: url('../../../assets/images/mall/top.png');
}
.asider-top-img-active {
  background-image: url('../../../assets/images/mall/top-active.png');
}
@keyframes navhover {
  from {
    transform: scaleX(0.2);
  }

  to {
    transform: scaleY(1);
  }
}
</style>
